import { Component, OnInit } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
import { AuthService } from '../providers/auth.service';
 
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  constructor(public router: Router, public authService: AuthService) {
    // console.log('nav constructor: ' + authService.displayName);
   }

  ngOnInit() {
  }

  loginGoogle() {
    this.authService.loginGoogle().then(user => this.router.navigate(['home']));
  }

  logout() {
    this.authService.logout().then(user => this.router.navigate(['home']));
  }

}


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/nav/nav.component.ts